var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtaSection07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 96,
    viewBox: "0 0 94 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6686 7.45691C47.1143 34.3837 28.4695 52.336 19.9464 65.9015L14.8354 74.0182L10.1062 65.2574C4.71738 55.3787 0.82941 52.7091 0.112542 58.4921C-0.519988 63.5947 1.50017 71.2138 6.55178 82.8928C11.2526 93.7225 14.2 96.6208 18.3133 94.7129C19.3943 94.2712 22.7081 88.695 25.657 82.3828C36.3012 59.9846 50.4258 42.6233 80.2461 15.4639C87.5749 8.77356 93.6963 2.62433 93.8087 1.7172C94.2444 -1.79794 89.7942 0.0682148 80.6686 7.45691Z",
    fill: "#D3EE34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaSection07);
export default __webpack_public_path__ + "static/media/cta_section_07.b27691d665b1dedaab69e673120688a6.svg";
export { ForwardRef as ReactComponent };